import React, { useContext } from 'react';
import Link from 'next/link';
import { StyleContext } from 'utils/context/StyleContextProvider';
import classNames from 'classnames';
import EmbedSignUp from 'components/forms/EmbedSignUp';
import {
    KLAVIYO,
    CD_BLOG_CATEGORIES,
    VLS_BLOG_CATEGORIES,
} from 'utils/constants';
import BlogArticles from './BlogArticles';
import Share from '../Tailwind/Components/Share';

export default function BlogBottom({ blog }) {
    const { categories, related, canonicalUrl, title } = blog,
        styles = useContext(StyleContext),
        { EMBED_BLOG_SIGNUP_FORM_ID } = KLAVIYO,
        BlogKeywords = () => (
            <div
                className={classNames(
                    styles.keywords,
                    'mt-5 flex flex-wrap items-center gap-x-15',
                )}
            >
                {categories.map((category) => {
                    const categorySlug = category.slug;

                    let categoryURL = `/blog/category/${categorySlug}`;
                    if (CD_BLOG_CATEGORIES.includes(categorySlug)) {
                        categoryURL =
                            'https://cancerdetect.viome.com/resources';
                    }
                    if (VLS_BLOG_CATEGORIES.includes(categorySlug)) {
                        categoryURL = `https://www.viomelifesciences.com/blog/category/${categorySlug}`;
                    }
                    return (
                        <Link
                            href={categoryURL}
                            key={category.title}
                            className="mt-2.5 rounded-3xl px-3.5 py-px lg:mt-8"
                        >
                            {category.title}
                        </Link>
                    );
                })}
            </div>
        );

    return (
        <div className={classNames(styles.bottom, 'mb-20 mt-8')}>
            <Share canonical={canonicalUrl} title={title} />
            <BlogKeywords />
            <div className={classNames(styles.signup, 'my-20 lg:my-40')}>
                <EmbedSignUp formId={EMBED_BLOG_SIGNUP_FORM_ID} />
            </div>
            {related && related.length > 0 && (
                <BlogArticles
                    blogArticles={{ blogs: related }}
                    limit={3}
                    title="Related Articles"
                />
            )}
        </div>
    );
}
